
import { Link, useNavigate, useRevalidator } from 'react-router'
import logo from '@/assets/logo.svg'
import styles from './Login.page.module.css'
import { authClient } from '@/lib/auth-client'
import { useState } from 'react'

export default function LoginPage() {
    const navigate = useNavigate()
    const {revalidate} = useRevalidator()
    const [emailInput, setEmailInput] = useState("")
    const [passwordInput, setPasswordInput] = useState("")
    const [rememberInput, setRememberInput] = useState(true)

    const emailError = !emailInput ? true : false
    const passwordError = !passwordInput ? true : false    

    const [error, setError] = useState(false)

    const handleChange = async (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        if(emailError || passwordError) return

        const res = await authClient.signIn.email({
            email: emailInput,
            password: passwordInput,
            rememberMe: rememberInput
        })

        if(res.data) {
            revalidate()
            navigate("/providers")
        } else {            
            setEmailInput("")
            setPasswordInput("")
            setError(true)
        }

    }

    return (
        <main className={styles.page}>
            <section className={styles.card}>                
                <Link to="/" className={styles.logo}>
                    <img src={logo} alt="MontaTec" />
                    <span>Proobi</span>
                </Link>
            
                <h1 className={styles.h1}>Inicia sesion</h1>                                    

                <form onSubmit={handleChange} className={styles.form}>
                    <label className={styles.label}>
                        <span>Correo electronico</span>
                        <input 
                            name="email" 
                            type="email" 
                            value={emailInput}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmailInput(e.currentTarget.value)}
                            placeholder="correo@empresa.com" 
                            className={error ? styles.error : ""}
                        />                                                    
                    </label>

                    <label className={styles.label}>
                        <span>Contrasena</span>                        
                        <input 
                            name="password" 
                            type="password" 
                            placeholder="Ingresa tu contrasena" 
                            value={passwordInput}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPasswordInput(e.currentTarget.value)}
                            className={error ? styles.error : ""}
                        />                                                    
                    </label>
                    {error && <span className={styles.invalid}>Correo y/o contraseña invalido/s.</span>}


                    <div className={styles.options}>
                        <label defaultChecked={rememberInput} className={styles.remember}>
                            <input checked={rememberInput} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRememberInput(e.currentTarget.checked)} type="checkbox" />
                            <span>Recordarme</span>
                        </label>
                    </div>
                    

                    <button className={`${styles.submit} ${emailError || passwordError ? styles.error : ""}`} type="submit" disabled={emailError || passwordError}>
                        Entrar al sistema
                    </button>
                </form>                
            </section>
        </main>
    )
}
